import { Alert, Form, Input, Modal, Typography } from "antd";
import { useEffect } from "react";

const { Text } = Typography;

interface NotApproveModalProps {
  open: boolean;
  initialReason: string;
  confirmLoading: boolean;
  errorMessage?: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export const NotApproveModal = ({
  open,
  initialReason,
  confirmLoading,
  errorMessage,
  onConfirm,
  onCancel,
}: NotApproveModalProps) => {
  const [form] = Form.useForm<{ reason: string }>();
  const reasonValue = Form.useWatch("reason", form);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ reason: initialReason });
    }
  }, [open, initialReason, form]);

  const handleConfirm = () => {
    form
      .validateFields()
      .then(({ reason }) => onConfirm(reason.trim()))
      .catch(() => undefined);
  };

  return (
    <Modal
      open={open}
      title="Not approve vessel data"
      okText="Confirm"
      okButtonProps={{ danger: true, disabled: !reasonValue?.trim() }}
      cancelButtonProps={{ disabled: confirmLoading }}
      confirmLoading={confirmLoading}
      closable={!confirmLoading}
      maskClosable={false}
      onOk={handleConfirm}
      onCancel={onCancel}
      destroyOnHidden
    >
      <Text type="secondary">
        The vessel goes on hold and orders are blocked until approved. Audit recipients are
        notified automatically.
      </Text>
      <Form form={form} layout="vertical" style={{ marginTop: 16 }} preserve={false}>
        <Form.Item
          label="Reason"
          name="reason"
          rules={[
            { required: true, whitespace: true, message: "Reason is required" },
            { max: 2000, message: "Reason must be 2000 characters or fewer" },
          ]}
        >
          <Input.TextArea
            rows={5}
            maxLength={2000}
            showCount
            autoFocus
            placeholder="Why is this vessel's data not approved?"
          />
        </Form.Item>
      </Form>
      {errorMessage && <Alert type="error" showIcon message={errorMessage} />}
    </Modal>
  );
};
